import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const aromaContextualIconDefaultVariants = {
  "size": "medium",
  "colorTheme": "neutral",
  "hierarchy": "bold"
}
const aromaContextualIconCompoundVariants = [
  {
    "hierarchy": "bolder",
    "colorTheme": "transparent",
    "css": {
      "svg": {
        "fill": "transparent"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "brand",
    "css": {
      "root": {
        "color": "content.brand.bold"
      },
      "svg": {
        "stroke": "border.brand-bold"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "brand",
    "css": {
      "root": {
        "color": "content.brand.bold"
      },
      "svg": {
        "stroke": "background.brand.subtle",
        "background": "background.brand.subtle"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "brand",
    "css": {
      "svg": {
        "stroke": "background.brand.bold",
        "background": "background.brand.bold"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "brand",
    "css": {
      "svg": {
        "stroke": "background.brand.bold-hover",
        "background": "background.brand.bold-hover"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "ai",
    "css": {
      "root": {
        "_aromaticonChildren": {
          "background": "content.ai",
          "color": "transparent",
          "backgroundClip": "text"
        }
      },
      "svg": {
        "stroke": "border.decorative.purple"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "ai",
    "css": {
      "root": {
        "_aromaticonChildren": {
          "background": "content.ai",
          "color": "transparent",
          "backgroundClip": "text"
        }
      },
      "svg": {
        "background": "background.ai.subtle",
        "stroke": "background.ai.bold"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "ai",
    "css": {
      "root": {
        "display": "none"
      },
      "svg": {
        "display": "none"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "ai",
    "css": {
      "svg": {
        "stroke": "background.ai.bold",
        "background": "background.ai.bold"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "neutral",
    "css": {
      "root": {
        "color": "content.neutral.base.subtlest"
      },
      "svg": {
        "stroke": "border.neutral.bold"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "neutral",
    "css": {
      "root": {
        "color": "content.neutral.base.subtlest"
      },
      "svg": {
        "stroke": "background.decorative.neutral.base-subtler",
        "background": "background.decorative.neutral.base-subtler"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "neutral",
    "css": {
      "svg": {
        "stroke": "background.decorative.neutral.base-bold",
        "background": "background.decorative.neutral.base-bold"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "neutral",
    "css": {
      "svg": {
        "stroke": "background.decorative.neutral.base-bolder",
        "background": "background.decorative.neutral.base-bolder"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "red",
    "css": {
      "root": {
        "color": "content.decorative.red"
      },
      "svg": {
        "stroke": "border.decorative.red"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "red",
    "css": {
      "svg": {
        "stroke": "background.decorative.red.base-subtler",
        "background": "background.decorative.red.base-subtler"
      },
      "root": {
        "color": "content.decorative.red"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "red",
    "css": {
      "svg": {
        "stroke": "background.decorative.red.base-bold",
        "background": "background.decorative.red.base-bold"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "red",
    "css": {
      "svg": {
        "stroke": "background.decorative.red.base-bolder",
        "background": "background.decorative.red.base-bolder"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "orange",
    "css": {
      "root": {
        "color": "content.decorative.orange"
      },
      "svg": {
        "stroke": "border.decorative.orange"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "orange",
    "css": {
      "svg": {
        "stroke": "background.decorative.orange.base-subtler",
        "background": "background.decorative.orange.base-subtler"
      },
      "root": {
        "color": "content.decorative.orange"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "orange",
    "css": {
      "svg": {
        "stroke": "background.decorative.orange.base-bold",
        "background": "background.decorative.orange.base-bold"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "orange",
    "css": {
      "svg": {
        "stroke": "background.decorative.orange.base-bolder",
        "background": "background.decorative.orange.base-bolder"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "yellow",
    "css": {
      "root": {
        "color": "content.decorative.yellow"
      },
      "svg": {
        "stroke": "border.decorative.yellow"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "yellow",
    "css": {
      "svg": {
        "stroke": "background.decorative.yellow.base-subtler",
        "background": "background.decorative.yellow.base-subtler"
      },
      "root": {
        "color": "content.decorative.yellow"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "yellow",
    "css": {
      "svg": {
        "stroke": "background.decorative.yellow.base-bold",
        "background": "background.decorative.yellow.base-bold"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "yellow",
    "css": {
      "svg": {
        "stroke": "background.decorative.yellow.base-bolder",
        "background": "background.decorative.yellow.base-bolder"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "green",
    "css": {
      "root": {
        "color": "content.decorative.green"
      },
      "svg": {
        "stroke": "border.decorative.green"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "green",
    "css": {
      "svg": {
        "stroke": "background.decorative.green.base-subtler",
        "background": "background.decorative.green.base-subtler"
      },
      "root": {
        "color": "content.decorative.green"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "green",
    "css": {
      "svg": {
        "stroke": "background.decorative.green.base-bold",
        "background": "background.decorative.green.base-bold"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "green",
    "css": {
      "svg": {
        "stroke": "background.decorative.green.base-bolder",
        "background": "background.decorative.green.base-bolder"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "blue",
    "css": {
      "root": {
        "color": "content.decorative.blue"
      },
      "svg": {
        "stroke": "border.decorative.blue"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "blue",
    "css": {
      "svg": {
        "stroke": "background.decorative.blue.base-subtler",
        "background": "background.decorative.blue.base-subtler"
      },
      "root": {
        "color": "content.decorative.blue"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "blue",
    "css": {
      "svg": {
        "stroke": "background.decorative.blue.base-bold",
        "background": "background.decorative.blue.base-bold"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "blue",
    "css": {
      "svg": {
        "stroke": "background.decorative.blue.base-bolder",
        "background": "background.decorative.blue.base-bolder"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "purple",
    "css": {
      "root": {
        "color": "content.decorative.purple"
      },
      "svg": {
        "stroke": "border.decorative.purple"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "purple",
    "css": {
      "svg": {
        "stroke": "background.decorative.purple.base-subtler",
        "background": "background.decorative.purple.base-subtler"
      },
      "root": {
        "color": "content.decorative.purple"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "purple",
    "css": {
      "svg": {
        "stroke": "background.decorative.purple.base-bold",
        "background": "background.decorative.purple.base-bold"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "purple",
    "css": {
      "svg": {
        "stroke": "background.decorative.purple.base-bolder",
        "background": "background.decorative.purple.base-bolder"
      }
    }
  },
  {
    "hierarchy": "subtlest",
    "colorTheme": "pink",
    "css": {
      "root": {
        "color": "content.decorative.pink"
      },
      "svg": {
        "stroke": "border.decorative.pink"
      }
    }
  },
  {
    "hierarchy": "subtle",
    "colorTheme": "pink",
    "css": {
      "svg": {
        "stroke": "background.decorative.pink.base-subtler",
        "background": "background.decorative.pink.base-subtler"
      },
      "root": {
        "color": "content.decorative.pink"
      }
    }
  },
  {
    "hierarchy": "bold",
    "colorTheme": "pink",
    "css": {
      "svg": {
        "stroke": "background.decorative.pink.base-bold",
        "background": "background.decorative.pink.base-bold"
      }
    }
  },
  {
    "hierarchy": "bolder",
    "colorTheme": "pink",
    "css": {
      "svg": {
        "stroke": "background.decorative.pink.base-bolder",
        "background": "background.decorative.pink.base-bolder"
      }
    }
  }
]

const aromaContextualIconSlotNames = [
  [
    "root",
    "aroma-contextual-icon__root"
  ],
  [
    "svg",
    "aroma-contextual-icon__svg"
  ]
]
const aromaContextualIconSlotFns = /* @__PURE__ */ aromaContextualIconSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, aromaContextualIconDefaultVariants, getSlotCompoundVariant(aromaContextualIconCompoundVariants, slotName))])

const aromaContextualIconFn = memo((props = {}) => {
  return Object.fromEntries(aromaContextualIconSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const aromaContextualIconVariantKeys = [
  "size",
  "colorTheme",
  "hierarchy"
]
const getVariantProps = (variants) => ({ ...aromaContextualIconDefaultVariants, ...compact(variants) })

export const aromaContextualIcon = /* @__PURE__ */ Object.assign(aromaContextualIconFn, {
  __recipe__: false,
  __name__: 'aromaContextualIcon',
  raw: (props) => props,
  variantKeys: aromaContextualIconVariantKeys,
  variantMap: {
  "size": [
    "small",
    "medium",
    "large",
    "xlarge",
    "jumbo"
  ],
  "colorTheme": [
    "brand",
    "neutral",
    "red",
    "orange",
    "yellow",
    "green",
    "blue",
    "purple",
    "pink",
    "ai",
    "transparent"
  ],
  "hierarchy": [
    "subtlest",
    "subtle",
    "bold",
    "bolder"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, aromaContextualIconVariantKeys)
  },
  getVariantProps
})